import styled from "styled-components";

// Chart and tile colors of the dashboard. The base colors are the values of
// --primary-color, --success-color and --danger-color in variables.css;
// ApexCharts derives its hover shades from the values, so they stay hex.
export const KPI_COLORS = {
  main: "#0d6efd",
  mainRunning: "#9ec5fe",
  target: "#198754",
  targetRunning: "#a3cfbb",
  campaign: "#6f42c1",
  campaignRunning: "#c5b3e6",
  targetLine: "#dc3545"
};

// long lists (e.g. early in a month) scroll inside the card
export const ListScroll = styled.div`
  max-height: 420px;
  overflow-y: auto;
`;
